//This is doing the translations- trasnaltion files are in now-ui-kit-react-master/public/locales/en
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';


// Die Uebersetzungsdateien werden zur Laufzeit per HTTP geladen und tragen -
// anders als die JS-/CSS-Bundles - keinen Hash im Dateinamen. Browser lieferten
// darum veraltete Kopien aus, in denen neu hinzugefuegte Keys fehlen; auf dem
// Screen erschien dann der rohe Key ("home.Sortiment title") statt des Textes.
// Der Parameter haengt die Cache-Sperre an die URL und muss nur erhoeht werden,
// falls die Datei erneut aus einem alten Cache kommt - regulaer sorgt die
// no-cache-Regel in public/.htaccess dafuer, dass Browser revalidieren.
const LOCALE_VERSION = '2026-08-23';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      queryStringParams: { v: LOCALE_VERSION },
    },
    whitelist: ['en', 'de', 'it'],
    // Browser melden Regionalcodes wie "en-US" oder "it-CH". Ohne
    // languageOnly stuenden die nicht in der whitelist und solche Besucher
    // bekaemen trotz vorhandener Uebersetzung die Rueckfallsprache Deutsch.
    // Zudem wuerde i18next /locales/en-US/translation.json anfragen (404).
    load: 'languageOnly',
    fallbackLng: 'de',
    debug: false, //logs changes to console on true

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;
